// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__U1hrM","player":"styles_player__8EX3l"};